import { render, staticRenderFns } from "./InterventionPlanProposition.vue?vue&type=template&id=084b27a2&scoped=true"
import script from "./InterventionPlanProposition.vue?vue&type=script&lang=js"
export * from "./InterventionPlanProposition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b27a2",
  null
  
)

export default component.exports